<template>
  <el-form ref="form" :model="form" label-width="180px" class="elForm">
    <p class="tips">以下数据可以不填，不填则表示没有此项积分，或者没有限制</p>
    <el-form-item label="注册会员成功：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 700px">
        <template slot="append">积分</template>
      </el-input>
    </el-form-item>
    <el-form-item label="完善个人资料：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 700px">
        <template slot="append">积分</template>
      </el-input>
    </el-form-item>
    <el-form-item label="手机验证：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 700px">
        <template slot="append">积分</template>
      </el-input>
    </el-form-item>
    <el-form-item label="邮箱验证：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 700px">
        <template slot="append">积分</template>
      </el-input>
    </el-form-item>
    <el-form-item label="每日登录：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 700px">
        <template slot="append">积分</template>
      </el-input>
      <span class="spanMaginFoot">会员每登录1次获赠积分数，同一会员每天多次登录仅算1次</span>
    </el-form-item>
    <el-form-item label="VIP会员员费：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 700px">
        <template slot="append">积分</template>
      </el-input>
    </el-form-item>
    <el-form-item label="邀请好友注册并首次消费：">
      <span class="spanMagin">固定积分</span>
      <el-input placeholder="请输入内容" v-model="input2" style="width: 200px">
        <template slot="append">积分</template>
      </el-input>
      <span class="spanMaginFoot">+首次订单积分（以好友成功消费所获积分为准）</span>
      <br /><br />
      <span class="spanMagin">每个用户ID邀请好友限制</span>
      <el-input placeholder="请输入内容" v-model="input2" style="width: 530px">
        <template slot="append">个</template>
      </el-input>
    </el-form-item>
    <el-form-item label="商品评论送积分：">
      <el-input placeholder="请输入内容" v-model="input2" style="width: 706px">
        <template slot="append">积分</template>
      </el-input>
      <span class="spanMaginFoot">每笔订单只有第一次评价送积分，后续评价不送</span>
      <br /><br />
      <span class="spanMagin">评论送积分有效期</span>
      <el-input placeholder="请输入内容" v-model="input2" style="width: 576px">
        <template slot="append">天</template>
      </el-input>
    </el-form-item>
    <el-form-item label="普通会员购物送积分：">
      <span class="spanMagin">订单支付金额（扣除运费）：积分数量为</span>
      <el-input placeholder="请输入内容" v-model="input2" style="width: 214px"></el-input>
      ：
      <el-input placeholder="请输入内容" v-model="input2" style="width: 214px"></el-input>
    </el-form-item>
    <el-form-item label="VIP会员购物送积分：">
      <span class="spanMagin">订单支付金额（扣除运费）：积分数量为</span>
      <el-input placeholder="请输入内容" v-model="input2" style="width: 214px"></el-input>
      ：
      <el-input placeholder="请输入内容" v-model="input2" style="width: 214px"></el-input>
    </el-form-item>
    <el-form-item label="普通会员服务送积分：">
      <span class="spanMagin" style="margin-right: 104px;">订单支付金额：积分数量为</span>
      <el-input placeholder="请输入内容" v-model="input2" style="width: 214px"></el-input>
      ：
      <el-input placeholder="请输入内容" v-model="input2" style="width: 214px"></el-input>
    </el-form-item>
    <el-form-item label="VIP会员服务送积分：">
      <span class="spanMagin"  style="margin-right: 104px;">订单支付金额：积分数量为</span>
      <el-input placeholder="请输入内容" v-model="input2" style="width: 214px"></el-input>
      ：
      <el-input placeholder="请输入内容" v-model="input2" style="width: 214px"></el-input>
    </el-form-item>
    <el-form-item label="积分清零时间：">
      <el-date-picker v-model="value1" type="date" placeholder="选择日期" style="width: 300px"></el-date-picker>
      <el-time-picker
        v-model="value1"
        :picker-options="{
          selectableRange: '18:30:00 - 20:30:00',
        }"
        placeholder="任意时间点"
        style="width: 300px; margin-left: 50px;"
      ></el-time-picker>
    </el-form-item>
    <el-form-item label="积分规则：">
      <RichText :richTxt="form.goods_details" @soninfo="val => (form.goods_details = val)"></RichText>
    </el-form-item>
    <el-form-item class="centerBtn">
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import RichText from '@/components/richText';
export default {
  components: {
    RichText,
  },
  data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
  },
};
</script>

<style lang="less" scoped>

* {
  color: gray;
}
.elForm {
  background-color: #fff;
  padding: 30px;
}

.centerBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tips {
  font-size: 14px;
  color: gray;
  padding: 30px 70px;
}

.spanMagin {
  margin-right: 20px;
}

.spanMaginFoot {
  margin-left: 20px;
}
</style>
